<template>
  <span
    >Workflow type from <b>{{ custom_id }}</b> has been changed to
    <b>{{ value.event.payload.workflow.name }}</b>
  </span>
</template>

<script>
export default {
  props: ["value"],
  metadata: {
    color: "orange",
    icon: "mdi-file-move",
    subscription_code: "workflow-change"
  },
  computed: {
    custom_id() {
      return this.value.event.payload && this.value.event.payload.metadata
        ? `${this.value.event.payload.metadata.custom_id} (${this.value.event.payload.metadata.content_revision_type})`
        : "";
    }
  }
};
</script>
